//* Libraries imports
import React from "react";

//* Components Imports
import HeroSection from "./components/HeroSection/HeroSection";
import OriginSection from "./components/OriginSection/OriginSection";
import WhySection from "./components/WhySection/WhySection";
import HowToRegisterSection from "./components/HowToRegisterSection/HowToRegisterSection";
import LogisticsSection from "./components/LogisticsSection/LogisticsSection";
import ErpSection from "./components/ErpSection/ErpSection";
import BuyerSection from "./components/BuyerSection/BuyerSection";
import FinancialSection from "./components/FinancialSection/FinancialSection";
import OrderCycleSection from "./components/OrderCycleSection/OrderCycleSection";
import ZeroInvestmentSection from "./components/ZeroInvestmentSection/ZeroInvestmentSection";

//* Styles Imports
import styles from "./styles.module.css";

function CadastroLojaPage({ dark_mode }) {
  return (
    <main
      id="cadastro-loja-main"
      data-testid="cadastro-loja-main"
      aria-label="Página de cadastro de novas lojas parceiras no iGooB"
      className={styles.pageContainer}
    >
      <HeroSection
        id="sub-hero-section"
        data-testid="sub-hero-section"
        aria-label="Seção de apresentação e capa"
        dark_mode={dark_mode}
      />
      <OriginSection
        id="sub-origin-section"
        data-testid="sub-origin-section"
        aria-label="Seção informativa sobre a origem da marca iGooB"
      />
      <BuyerSection
        id="sub-buyer-section"
        data-testid="sub-buyer-section"
        aria-label="Seção sobre a jornada de compra e o novo consumidor"
      />
      <WhySection
        id="sub-why-section"
        data-testid="sub-why-section"
        aria-label="Seção informativa dos benefícios de cadastro"
      />
      <ErpSection
        id="sub-erp-section"
        data-testid="sub-erp-section"
        aria-label="Seção informativa sobre integração automática de estoque e preços"
      />
      <HowToRegisterSection
          id="sub-how-to-register-section"
          data-testid="sub-how-to-register-section"
          aria-label="Seção do passo a passo para se cadastrar"
        />
      <LogisticsSection
        id="sub-logistics-section"
        data-testid="sub-logistics-section"
        aria-label="Seção informativa sobre a frota de entregas dedicada"
      />
      <FinancialSection
        id="sub-financial-section"
        data-testid="sub-financial-section"
        aria-label="Seção sobre as regras de repasses financeiros"
      />
      <OrderCycleSection
        id="sub-order-cycle-section"
        data-testid="sub-order-cycle-section"
        aria-label="Seção com a timeline das etapas do pedido"
      />
      <ZeroInvestmentSection
        id="sub-zero-investment-section"
        data-testid="sub-zero-investment-section"
        aria-label="Seção informativa sobre investimento zero e comissionamento por venda"
      />
    </main>
  );
}

export default CadastroLojaPage;
